import * as z from 'zod';

export const EventStatusSchema = z.enum(['open', 'closed', 'imported', 'rejected', 'cancelled']);
export type EventStatus = z.infer<typeof EventStatusSchema>;
